<script>
import { mapGetters } from 'vuex';

import CostService from "@/store/services/cost.service.js";
import InvoiceService from '@/store/services/invoice.service.js';
import TripService from '@/store/services/trip.service';
import HourService from '@/store/services/hour.service';
import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";

export default {
  name: "TotalAmountsCustomer",
  extends: TotalAmountsBase,
  data() {
    return {
      mutationName: 'filterStore/SET_UPDATE_FILTER_CUSTOMER_INSIGHT'
    }
  },
  computed: {
    ...mapGetters({ 
      getCompanyId: 'main/getCompanyId'
    }),
  },
  methods: {
    getTotalAmounts(){
      if(Object.keys(this.filters).length !== 0){
        this.loading = true
        if(!this.filters.owner_company){
          this.filters.owner_company = this.getCompanyId;
        }
        if(this.filters.report_option == 0){
          let filters_costs = {
            'start_date': this.filters.start_date,
            'end_date': this.filters.end_date,
            'group_by': 'customer',
            'owner_company': this.getCompanyId,
            'tax_exists': true,
            'tax_exempt': true,
            'btw_reversed_charge': true
          }

          let filters_invoices = {
            'start_date': this.filters.start_date,
            'end_date': this.filters.end_date,
            'group_by' : 'recipient_customer',
            'sender_company': this.getCompanyId,
            'status': 'p,s'
          }

          let promises = []
          promises.push(CostService.totalNet(filters_costs))
          promises.push(InvoiceService.totalNet(filters_invoices))

          Promise.all(promises).then((responses) => {
            this.loading = false
            this.amountUnitFormat = "euro"
            this.amountsList = []
            let revenue_total = 0
            let cost_total = 0
            responses[0].data.forEach((customer) => cost_total += customer.total_net)
            responses[1].data.forEach((customer) => revenue_total += customer.total)
            this.amountsList.push({text: this.$gettext("REVENUE"), amount: revenue_total, class:'text-brand'})
            this.amountsList.push({text: this.$gettext("COST"), amount: cost_total, class:'text-blue'})
          })
        }
        else if(this.filters.report_option == 1){
          let filters_invoices = {
            'start_date': this.filters.start_date,
            'end_date': this.filters.end_date,
            'group_by' : 'recipient_customer',
            'sender_company': this.getCompanyId,
            'status': 'p,s'
          }
          InvoiceService.totalNet(filters_invoices).then((response) => {
            this.loading = false
            this.amountUnitFormat = "euro"
            this.amountsList = []
            let revenue_total = 0
            response.data.forEach((customer) => revenue_total += customer.total)
            this.amountsList.push({text: this.$gettext("REVENUE"), amount: revenue_total, class:'text-brand'})
          })

        }
        else if(this.filters.report_option == 2){ 
          TripService.getTotals(this.filters).then((response) => {
            this.loading = false
            this.amountUnitFormat = ''
            this.amountsList = []
            this.amountsList.push({text: this.$gettext("TOTAL"), amount: response.data.total_business + " KM", class:'text-brand'})
          })
        }
        else {
          HourService.getTotals(this.filters).then((response) => {
            this.loading = false
            this.amountUnitFormat = "hours"
            this.amountsList = []
            this.amountsList.push({text: this.$gettext("INVOICED"), amount: response.data.invoiced, class:'text-brand'})
            this.amountsList.push({text: this.$gettext("UNINVOICED"), amount: response.data.uninvoiced, class:'text-brand'})
            this.amountsList.push({text: this.$gettext("TOTAL"), amount: response.data.total, class:'text-brand'})
          })
        }
    }
    }
  }
};
</script>